forms-orders-files-create
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }" enctype="multipart/form-data")
    .row
      .col-md-8.offset-md-4
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
        .file-wrap.mb-1(each="{ item in files }")
          input.file-input(type="file" name="files[][file]")
          input.form-control(name="files[][filename]" type="text" value="{item.filename}" placeholder="ファイル名" onChange="{ this.onChangeName }")
        label.file-label.btn.btn-success.btn-sm
          input(type="file" multiple onChange="{ this.onChangeFile }")
          i.fa.fa-plus.mr-1
          span ファイルを選択
    div(if="{this.files.length > 0}")
      inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.orders.files.create');
  style(scoped).
    input[type="file"] {
      display: none;
    }
    .file-label span{
      width: 7rem;
      display: inline-block;
    }
